/**
 * Producer status helpers
 * 
 * Handles the producer_status field which controls business/account status
 * independent of the public/draft visibility status.
 */

export type ProducerBusinessStatus = 'pending' | 'active' | 'paused' | 'banned';

/**
 * Check if producer can publish (profile, products, events)
 */
export function canPublish(status: ProducerBusinessStatus | string | null | undefined): boolean {
  return status === 'active';
}

/**
 * Check if producer status is pending (building mode)
 */
export function isPending(status: ProducerBusinessStatus | string | null | undefined): boolean {
  return status === 'pending';
}

/**
 * Check if producer is blocked (paused or banned)
 */
export function isBlocked(status: ProducerBusinessStatus | string | null | undefined): boolean {
  return status === 'paused' || status === 'banned';
}

/**
 * Get Swedish label for producer status
 */
export function getProducerStatusLabel(status: ProducerBusinessStatus | string | null | undefined): string {
  switch (status) {
    case 'pending':
      return 'Byggläge';
    case 'active':
      return 'Aktivt';
    case 'paused':
      return 'Pausad';
    case 'banned':
      return 'Avstängd';
    default:
      return 'Okänd status';
  }
}

/**
 * Get badge variant for producer status
 */
export function getProducerStatusBadgeVariant(status: ProducerBusinessStatus | string | null | undefined): 'default' | 'secondary' | 'destructive' | 'outline' {
  switch (status) {
    case 'active':
      return 'default';
    case 'pending':
      return 'secondary';
    case 'paused':
      return 'outline';
    case 'banned':
      return 'destructive';
    default:
      return 'outline';
  }
}
